import React from 'react';
import { Upload } from 'lucide-react';

interface GuestPhotosGridSectionProps {
  language: 'en' | 'mr';
}

export const GuestPhotosGridSection: React.FC<GuestPhotosGridSectionProps> = ({ language }) => {
  const [photos, setPhotos] = React.useState<string[]>([]);

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          if (typeof event.target?.result === 'string') {
            setPhotos((prev) => [...prev, event.target.result as string]);
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  return (
    <section className="relative py-24 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 mb-4">
          {language === 'mr' ? 'पार्टीचे क्षण शेअर करा' : 'Share Your Party Moments'}
        </h2>
        <p className="text-center text-gray-400 mb-12">
          {language === 'mr' ? 'आपले फोटो आपल्या समस्या सामग्री मध्ये दिसेल' : 'Share photos from the party'}
        </p>

        {/* Upload Area */}
        <div className="mb-12">
          <label className="group relative block cursor-pointer">
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handlePhotoUpload}
              className="hidden"
            />
            <div className="border-2 border-dashed border-cyan-400 rounded-2xl p-12 text-center hover:bg-cyan-400/5 transition-all group-hover:border-pink-400">
              <Upload className="w-12 h-12 text-cyan-400 mx-auto mb-4" />
              <p className="text-white font-bold text-lg">
                {language === 'mr' ? 'फोटो यहाँ ड्रॅग करा किंवा क्लिक करा' : 'Drag photos here or click to upload'}
              </p>
              <p className="text-gray-400 text-sm mt-2">
                {language === 'mr' ? 'PNG, JPG किंवा GIF' : 'PNG, JPG or GIF'}
              </p>
            </div>
          </label>
        </div>

        {/* Photos Grid */}
        {photos.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {photos.map((photo, idx) => (
              <div key={idx} className="group relative aspect-square overflow-hidden rounded-lg border border-slate-700 hover:border-cyan-400 transition-all">
                <img
                  src={photo}
                  alt={`Guest photo ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={() => setPhotos((prev) => prev.filter((_, i) => i !== idx))}
                    className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-red-600"
                  >
                    ✕
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {photos.length === 0 && (
          <div className="text-center text-gray-500 py-12">
            {language === 'mr' ? 'कोणतेही फोटो अपलोड केलेले नाहीत' : 'No photos uploaded yet'}
          </div>
        )}
      </div>
    </section>
  );
};
